export default __webpack_public_path__ + "static/media/fxdx-logo-glow.83c5aea5.png";